/* eslint-disable no-fallthrough */
import { docConfigActionTypes } from '@Actions/docConfigActions';

const DocConfigReducers = (state = {}, action) => {
  switch (action.type) {
    case docConfigActionTypes.GET_DOC_CONFIG.LOADING: {
      const { getDocConfigLoading, entityName } = action;

      if (entityName === 'PRODUCTS') {
        return {
          ...state,
          getDocConfigProductLoading: getDocConfigLoading,
        };
      }
      if (entityName === 'PURCHASE_ORDER') {
        return {
          ...state,
          getDocConfigPOLoading: getDocConfigLoading,
        };
      }
      if (entityName === 'GOOD_RECEIVING_NOTES') {
        return {
          ...state,
          getDocConfigGRNLoading: getDocConfigLoading,
        };
      }
      if (entityName === 'ACCOUNT_PAYABLE_INVOICE') {
        return {
          ...state,
          getDocConfigAPInvoiceLoading: getDocConfigLoading,
        };
      }
      if (entityName === 'SALES_ESTIMATE') {
        return {
          ...state,
          getDocConfigSELoading: getDocConfigLoading,
        };
      }
      if (entityName === 'SALES_ORDER') {
        return {
          ...state,
          getDocConfigSOLoading: getDocConfigLoading,
        };
      }
      if (entityName === 'PACKING_SLIP') {
        return {
          ...state,
          getDocConfigPSLoading: getDocConfigLoading,
        };
      }
      if (entityName === 'INVOICE') {
        return {
          ...state,
          getDocConfigInvoiceLoading: getDocConfigLoading,
        };
      }
      if (entityName === 'CONSUMPTION_ORDER') {
        return {
          ...state,
          getDocConfigCOLoading: getDocConfigLoading,
        };
      }
      if (entityName === 'MANUFACTURING_ORDER') {
        return {
          ...state,
          getDocConfigMOLoading: getDocConfigLoading,
        };
      }
      if (entityName === 'MANUAL_PRODUCTION_ENTRY') {
        return {
          ...state,
          getDocConfigMPELoading: getDocConfigLoading,
        };
      }
      if (entityName === 'JOB_WORK') {
        return {
          ...state,
          getDocConfigJWLoading: getDocConfigLoading,
        };
      }
      if (entityName === 'VENDOR_PAYOUT') {
        return {
          ...state,
          getDocConfigVendorPayoutLoading: getDocConfigLoading,
        };
      }
      if (entityName === 'STOCK_TRANSFER') {
        return {
          ...state,
          getDocConfigStockTransferLoading: getDocConfigLoading,
        };
      }
      if (entityName === 'STOCK_ADJUSTMENT') {
        return {
          ...state,
          getDocConfigStockAdjustmentLoading: getDocConfigLoading,
        };
      }
      if (entityName === 'debit_note') {
        return {
          ...state,
          getDocConfigDebitNoteLoading: getDocConfigLoading,
        };
      }
      if (entityName === 'CREDIT_NOTE') {
        return {
          ...state,
          getDocConfigCreditNoteLoading: getDocConfigLoading,
        };
      }
      if (entityName === 'RETURN_SLIP') {
        return {
          ...state,
          getDocConfigReturnSlipLoading: getDocConfigLoading,
        };
      }
      if (entityName === 'DELIVERY_CHALLAN') {
        return {
          ...state,
          getDocConfigDeliveryChallanLoading: getDocConfigLoading,
        };
      }
      if (entityName === 'VENDORS') {
        return {
          ...state,
          getDocConfigVendorLoading: getDocConfigLoading,
        };
      }
      if (entityName === 'CUSTOMERS') {
        return {
          ...state,
          getDocConfigCustomerLoading: getDocConfigLoading,
        };
      }
      if (entityName === 'EXPENSE') {
        return {
          ...state,
          getDocConfigExpenseLoading: getDocConfigLoading,
        };
      }
      if (entityName === 'BILL_OF_MATERIAL') {
        return {
          ...state,
          getDocConfigBOMLoading: getDocConfigLoading,
        };
      }
      if (entityName === 'REQUEST_FOR_QUOTATION') {
        return {
          ...state,
          getDocConfigRFQLoading: getDocConfigLoading,
        };
      }
      if (entityName === 'PURCHASE_REQUEST') {
        return {
          ...state,
          getDocConfigPRLoading: getDocConfigLoading,
        };
      }
      if (entityName === 'PURCHASE_INDENT') {
        return {
          ...state,
          getDocConfigPILoading: getDocConfigLoading,
        };
      }
      if (entityName === 'QUALITY_CHECKS') {
        return {
          ...state,
          getDocConfigQCLoading: getDocConfigLoading,
        };
      }
      if (entityName === 'DEBIT_NOTE') {
        return {
          ...state,
          getDocConfigDNLoading: getDocConfigLoading,
        };
      }
      if (entityName === 'ANNUAL_MAINTENANCE_CONTRACT') {
        return {
          ...state,
          getDocConfigAnnualMaintenanceContractLoading: getDocConfigLoading,
        };
      }
      if (entityName === 'CERTIFICATE_OF_ANALYSIS') {
        return {
          ...state,
          getDocConfigCOALoading: getDocConfigLoading,
        };
      }
      if (entityName === 'EXPORT_PACKING_SLIP') {
        return {
          ...state,
          getDocConfigExportPackingSlipLoading: getDocConfigLoading,
        };
      }
      if (entityName === 'EXPORT_INVOICE') {
        return {
          ...state,
          getDocConfigExportInvoiceLoading: getDocConfigLoading,
        };
      }
      if (entityName === 'EXPORT_CUSTOM_PACKING_SLIP') {
        return {
          ...state,
          getDocConfigExportCustomPackingSlipLoading: getDocConfigLoading,
        };
      }
      if (entityName === 'EXPORT_COMMERCIAL_PACKING_SLIP') {
        return {
          ...state,
          getDocConfigExportCommercialPackingSlipLoading: getDocConfigLoading,
        };
      }
      if (entityName === 'EXPORT_CUSTOM_INVOICE') {
        return {
          ...state,
          getDocConfigExportCustomInvoiceLoading: getDocConfigLoading,
        };
      }
      if (entityName === 'EXPORT_COMMERCIAL_INVOICE') {
        return {
          ...state,
          getDocConfigExportCommercialInvoiceLoading: getDocConfigLoading,
        };
      }
    }

    case docConfigActionTypes.GET_DOC_CONFIG.SUCCESS: {
      const { docConfig, entityName } = action;
      if (entityName === 'PRODUCTS') {
        return {
          ...state,
          docConfigProduct: docConfig,
        };
      }
      if (entityName === 'PURCHASE_ORDER') {
        return {
          ...state,
          docConfigPO: docConfig,
        };
      }
      if (entityName === 'GOOD_RECEIVING_NOTES') {
        return {
          ...state,
          docConfigGRN: docConfig,
        };
      }
      if (entityName === 'ACCOUNT_PAYABLE_INVOICE') {
        return {
          ...state,
          docConfigAPInvoice: docConfig,
        };
      }
      if (entityName === 'SALES_ESTIMATE') {
        return {
          ...state,
          docConfigSE: docConfig,
        };
      }
      if (entityName === 'SALES_ORDER') {
        return {
          ...state,
          docConfigSO: docConfig,
        };
      }
      if (entityName === 'PACKING_SLIP') {
        return {
          ...state,
          docConfigPS: docConfig,
        };
      }
      if (entityName === 'INVOICE') {
        return {
          ...state,
          docConfigInvoice: docConfig,
        };
      }
      if (entityName === 'CONSUMPTION_ORDER') {
        return {
          ...state,
          docConfigCO: docConfig,
        };
      }
      if (entityName === 'MANUFACTURING_ORDER') {
        return {
          ...state,
          docConfigMO: docConfig,
        };
      }
      if (entityName === 'MANUAL_PRODUCTION_ENTRY') {
        return {
          ...state,
          docConfigMPE: docConfig,
        };
      }
      if (entityName === 'JOB_WORK') {
        return {
          ...state,
          docConfigJW: docConfig,
        };
      }
      if (entityName === 'VENDOR_PAYOUT') {
        return {
          ...state,
          docConfigVendorPayout: docConfig,
        };
      }
      if (entityName === 'STOCK_TRANSFER') {
        return {
          ...state,
          docConfigStockTransfer: docConfig,
        };
      }
      if (entityName === 'STOCK_ADJUSTMENT') {
        return {
          ...state,
          docConfigStockAdjustment: docConfig,
        };
      }
      if (entityName === 'debit_note') {
        return {
          ...state,
          docConfigDebitNote: docConfig,
        };
      }
      if (entityName === 'CREDIT_NOTE') {
        return {
          ...state,
          docConfigCreditNote: docConfig,
        };
      }
      if (entityName === 'RETURN_SLIP') {
        return {
          ...state,
          docConfigReturnSlip: docConfig,
        };
      }
      if (entityName === 'DELIVERY_CHALLAN') {
        return {
          ...state,
          docConfigDeliveryChallan: docConfig,
        };
      }
      if (entityName === 'VENDORS') {
        return {
          ...state,
          docConfigVendor: docConfig,
        };
      }
      if (entityName === 'CUSTOMERS') {
        return {
          ...state,
          docConfigCustomer: docConfig,
        };
      }
      if (entityName === 'EXPENSE') {
        return {
          ...state,
          docConfigExpense: docConfig,
        };
      }
      if (entityName === 'BILL_OF_MATERIAL') {
        return {
          ...state,
          docConfigBOM: docConfig,
        };
      }
      if (entityName === 'REQUEST_FOR_QUOTATION') {
        return {
          ...state,
          docConfigRFQ: docConfig,
        };
      }
      if (entityName === 'PURCHASE_REQUEST') {
        return {
          ...state,
          docConfigPR: docConfig,
        };
      }
      if (entityName === 'PURCHASE_INDENT') {
        return {
          ...state,
          docConfigPI: docConfig,
        };
      }
      if (entityName === 'QUALITY_CHECKS') {
        return {
          ...state,
          docConfigQC: docConfig,
        };
      }
      if (entityName === 'DEBIT_NOTE') {
        return {
          ...state,
          docConfigDN: docConfig,
        };
      }
      if (entityName === 'ANNUAL_MAINTENANCE_CONTRACT') {
        return {
          ...state,
          docConfigAnnualMaintenanceContract: docConfig,
        };
      }
      if (entityName === 'CERTIFICATE_OF_ANALYSIS') {
        return {
          ...state,
          docConfigCOA: docConfig,
        };
      }
      if (entityName === 'EXPORT_PACKING_SLIP') {
        return {
          ...state,
          docConfigExportPackingSlip: docConfig,
        };
      }
      if (entityName === 'EXPORT_INVOICE') {
        return {
          ...state,
          docConfigExportInvoice: docConfig,
        };
      }
      if (entityName === 'EXPORT_CUSTOM_PACKING_SLIP') {
        return {
          ...state,
          docConfigExportCustomPackingSlip: docConfig,
        };
      }
      if (entityName === 'EXPORT_COMMERCIAL_PACKING_SLIP') {
        return {
          ...state,
          docConfigExportCommercialPackingSlip: docConfig,
        };
      }
      if (entityName === 'EXPORT_CUSTOM_INVOICE') {
        return {
          ...state,
          docConfigExportCustomInvoice: docConfig,
        };
      }
      if (entityName === 'EXPORT_COMMERCIAL_INVOICE') {
        return {
          ...state,
          docConfigExportCommercialInvoice: docConfig,
        };
      }
    }

    case docConfigActionTypes.UPDATE_DOC_CONFIG.LOADING: {
      const { updateDocConfigLoading } = action;
      return {
        ...state,
        updateDocConfigLoading,
      };
    }

    default: {
      return state;
    }
  }
};

export default DocConfigReducers;
